module.exports = __webpack_public_path__ + "img/logo_footer.331770e1.png";